export default __webpack_public_path__ + "static/media/icon-inprocess.bb80d883.svg";